module.exports = __webpack_public_path__ + "img/what-happens-desktop-fr.0eac07ab.webp";